import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { IDS } from "../../utils/IDS";
import { Select2Data } from "../../utils/common";

export const AllReceviables = createAsyncThunk(
  "common/managepoints/receviables",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllReceviables}`);
      //  console.log(res, "All AllReceviables data");
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTransferable = createAsyncThunk(
  "common/managepoints/transferable",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTransferable}`);
      //  console.log(res, "All AllReceviables data");
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//  Create (Add)
export const Create = createAsyncThunk(
  "common/managepoints/transferpoint",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Commons.TransferPoint, data);
      return res; // The new country object
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const Status = createAsyncThunk(
  "common/managepoints/status",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Commons.StatusPoint, data);
      return res; // The new country object
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const AllAgentPanelText = createAsyncThunk(
  "common/agentpanel/text",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AgentPanelText}`);
      console.log(res, "All AllReceviables data");
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllFunTargetResult = createAsyncThunk(
  "common/fun-target-result/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.FunTagregtResult}`);
      //  console.log(res, "All AllReceviables data");
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllRouletteResult = createAsyncThunk(
  "common/roulette-result/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.RouletteResult}`);
      //  console.log(res, "All AllReceviables data");
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    data: {},
    all_receviable: [],
    all_transferable: [],
    all_agentpaneltext: {},
    all_fun_target_result: {},
    all_roulette_result: {},
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllReceviables.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllReceviables.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_receviable = action.payload || [];
      })
      .addCase(AllReceviables.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTransferable.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTransferable.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_transferable = action.payload || [];
      })
      .addCase(AllTransferable.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = action.payload;
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = action.payload;
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAgentPanelText.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAgentPanelText.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.all_agentpaneltext = action.payload;
      })
      .addCase(AllAgentPanelText.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllFunTargetResult.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFunTargetResult.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_fun_target_result = action.payload || [];
      })
      .addCase(AllFunTargetResult.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllRouletteResult.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRouletteResult.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_roulette_result = action.payload || [];
      })
      .addCase(AllRouletteResult.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
